import type { DealEventTct } from '@dealstack/shared/lib/backendClient';
import { formatTableNameToLabel } from '@dealstack/frontend/shared/components/Audit/AuditLayout/utils.ts';
import { normalizeScreamingSnakeToUI } from '@dealstack/shared/lib/format/string';
import { isAuditedTable } from '@dealstack/shared/lib/common/business/dealEvent';
import {
	formatAccessHeading,
	formatAuthHeading,
} from '@dealstack/frontend/app/pages/Project/DealEventLog/dealEventLog.utils.ts';

type Translate = (key: string) => string;

export const formatEventTypeLabel = (event: DealEventTct, t: Translate): string => {
	if (event.auth) {
		return formatAuthHeading(event.auth.action, t);
	}

	if (event.access) {
		return formatAccessHeading(event.access.action, t);
	}

	// Not an audited table: name it by where it came from, and let the Event column say what.
	return isAuditedTable(event.entity.type)
		? formatTableNameToLabel(event.entity.type, t)
		: normalizeScreamingSnakeToUI(event.source);
};
